<template>
  <div
    v-show="visible"
    class="c-epg-popover"
    @mouseover="preventHide = true"
    @mouseleave="hide"
  >
    <div class="c-epg-popover__info">
      <div>
        <p class="c-epg-popover__meta u-ellipsis-5-lines">
          {{ product | meta('description') }}
        </p>
      </div>
    </div>
    <v-product-image
      :product="product"
      class="c-epg-popover__cover"
    ></v-product-image>
    <div
      class="c-epg-popover__arrow js-popover-arrow"
      :class="`c-epg-popover__arrow--${placement}`"
    ></div>
  </div>
</template>
<script>
  import * as dom from '@atds-legacy/dom';
  import { delay } from '@/shared/libs/helpers';
  import { dateFormat, meta, truncate } from '@/index/shared/filters';
  import { productMixin } from '@/index/shared/mixins';
  import VProductImage from '../product-image/index.vue';

  export default {
    components: {
      VProductImage,
    },
    filters: {
      dateFormat,
      meta,
      truncate,
    },
    mixins: [
      productMixin,
    ],
    props: {
      channels: Array,
    },
    data() {
      return {
        visible: false,
        target: null,
        hidePromise: Promise.resolve(),
        preventHide: false,
        product: {},
        placement: 'up',
      };
    },
    methods: {
      show(product, target) {
        this.preventHide = true;

        if (product && this.target !== target) {
          this.hidePromise.then(() => {
            this.product = product;
            this.visible = true;
            this.target = target;
            this.$nextTick(this.position);
          });
        }
      },
      hide() {
        this.preventHide = false;

        this.hidePromise = delay(400).then(() => {
          if (this.$el && !this.preventHide) {
            this.visible = false;
            this.target = undefined;
          }
        });
      },
      position() {
        let left;
        let top;
        let placement = 'right';
        let popover = dom.getSize(this.$el);
        const arrow = this.$el.querySelector('.js-popover-arrow');
        const scroll = dom.getScrollPosition(window);
        const target = dom.getAbsoluteRect(this.target);
        const viewport = dom.getAbsoluteRect(document.body);
        const viewportOffset = 10;
        const arrowBaseOffset = -11;

        const fits = (dir) => {
          switch (dir) {
            case 'right':
              return (target.right + popover.width) - scroll.left < viewport.right - viewportOffset;
            case 'left':
              return target.left - popover.width - scroll.left > viewport.left + viewportOffset;
            case 'top':
              return target.top - popover.height - scroll.top > viewport.top + viewportOffset;
            case 'bottom':
              return (target.bottom + popover.height) - scroll.top < viewport.bottom - viewportOffset;
          }
          return false;
        };

        if (!fits(placement)) {
          placement = 'left';
        }
        if (!fits(placement)) {
          placement = 'top';
        }
        if (!fits(placement)) {
          placement = 'bottom';
        }
        // we can do nothing - popover will not be shown
        if (!fits(placement)) {
          return;
        }

        if (placement === 'right' || placement === 'left') {
          top = (target.top - (popover.height / 2)) + (target.height / 2);
        } else if (placement === 'top') {
          top = target.top - popover.height;
        } else {
          top = target.bottom;
        }

        if (placement === 'top' || placement === 'bottom') {
          left = (target.left - (popover.width / 2)) + (target.width / 2);
        } else if (placement === 'right') {
          left = target.right;
        } else {
          left = (target.left - popover.width) + 3;
        }
        this.$el.dataset.placement = placement;

        const pos = { top, left };
        this.$el.style.top = pos.top + 'px';
        this.$el.style.left = pos.left + 'px';
        arrow.style.marginLeft = 0; // reset arrow position

        // adjust horizontal offset for top/bottom
        if (placement === 'top' || placement === 'bottom') {
          arrow.style.marginLeft = arrowBaseOffset + 'px';
          popover = dom.getAbsoluteRect(this.$el);
          const offsets = {
            right: (viewport.right - viewportOffset) - (popover.right - scroll.left),
            left: (popover.left - scroll.left) - (viewport.left + viewportOffset),
          };

          let offset;
          if (offsets.right < 0) {
            pos.left += offsets.right;
            offset = -offsets.right;
          }
          if (offsets.left < 0) {
            pos.left -= offsets.left;
            offset = offsets.left;
          }

          this.$el.style.top = pos.top + 'px';
          this.$el.style.left = pos.left + 'px';
          if (offset) {
            const sign = offset / Math.abs(offset);
            const epgOffset = (sign > 0) ? 200 : 250;
            const max = (popover.width - epgOffset) / 2;
            if (Math.abs(offset) > max) {
              offset -= sign * (Math.abs(offset) - max);
            }
            arrow.style.marginLeft = offset + arrowBaseOffset + 'px';
          }
        }

        this.placement = placement;

        this.$nextTick(() => {
          this.$el.style.visibility = 'visible';
          this.target.classList.add('active');
        });
      },
    },
  };
</script>
